/** Nivel territorial del dato de temperatura. */
export type TemperatureLevel = "department" | "province";

/**
 * Temperatura observada en el punto representativo (centroide) de una unidad
 * territorial del Perú (departamento o provincia) del Perú.
 *
 * El dato crudo proviene de Open-Meteo (modelo meteorológico abierto); la
 * unidad territorial y su geometría provienen de los límites censales
 * oficiales del MIDAGRI (SERV_LIMITE_CENSAL).
 */
export class TemperatureUnitEntity {
  constructor(
    /** Código ubigeo: 2 dígitos (departamento) o 4 (departamento+provincia). */
    public readonly code: string,
    /** Nombre oficial de la unidad ("Cusco", "La Convención"…). */
    public readonly name: string,
    /** Nivel territorial de la unidad. */
    public readonly level: TemperatureLevel,
    /** Longitud del centroide (WGS84). */
    public readonly longitude: number,
    /** Latitud del centroide (WGS84). */
    public readonly latitude: number,
    /** Temperatura actual a 2 m (°C); null si el punto quedó sin dato. */
    public readonly temperature: number | null,
    /** Mínima prevista del día (°C); null si el punto quedó sin dato. */
    public readonly temperatureMin: number | null,
    /** Máxima prevista del día (°C); null si el punto quedó sin dato. */
    public readonly temperatureMax: number | null,
    /** Instante ISO de la observación; null si el punto quedó sin dato. */
    public readonly observedAt: string | null,
    /**
     * Geometría del polígono de la unidad en esriJSON
     * (`{ rings: number[][][], spatialReference }`). null si no se solicitó.
     */
    public readonly geometry: unknown = null,
  ) {}
}
